import { render, staticRenderFns } from "./openLoading.vue?vue&type=template&id=abef8354&scoped=true&"
import script from "./openLoading.vue?vue&type=script&lang=js&"
export * from "./openLoading.vue?vue&type=script&lang=js&"
import style0 from "./openLoading.vue?vue&type=style&index=0&id=abef8354&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abef8354",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/ecommerce_h5_dev_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('abef8354', component.options)
    } else {
      api.reload('abef8354', component.options)
    }
    module.hot.accept("./openLoading.vue?vue&type=template&id=abef8354&scoped=true&", function () {
      api.rerender('abef8354', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/main/openLoading.vue"
export default component.exports